import React from 'react';
import { Link } from 'react-router-dom';
import './HeroBanner.css';

const HeroBanner: React.FC = () => {
  return (
    <section className="hero-banner">
      <div className="container">
        <div className="hero-banner-inner">

          <div className="hero-banner-image">
            <div className="hero-image-glow" />
            <img
              src="/KaviImage.jpeg"
              alt="Astrologer Kavitha Nandy"
              className="hero-photo"
            />
          </div>

          <div className="hero-banner-content">
            <div className="hero-badge">✨ Vedic Astrologer & Cosmic Guide</div>
            <h1>Astrologer Kavitha Nandy</h1>
            <p className="hero-summary">
              With over 15 years of dedicated study in Vedic astrology, I carry forward a legacy
              rooted in my grandfather Professor K. V. Sahukar's lifelong practice. Trained in the
              lineage of Dr. K. N. Rao, I blend classical Brihat Parashara Hora Shastra with a
              modern, compassionate approach, helping you uncover purpose, timing, and direction
              written in the stars at the moment of your birth.
            </p>

            <div className="hero-highlights">
              <div className="highlight-item">
                <span className="highlight-number">15+</span>
                <span className="highlight-label">Years of Practice</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number">5</span>
                <span className="highlight-label">Services Offered</span>
              </div>
              <div className="highlight-item">
                <span className="highlight-number">100%</span>
                <span className="highlight-label">Personalised Readings</span>
              </div>
            </div>

            <div className="hero-banner-ctas">
              <Link to="/submit-details" className="cta-button">Book a Reading</Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
